import { IResponsePagination } from "./pagination.types";
import { IBuildingConfigDetails } from "./settings.types";

export type CustomerStatusType = "Active" | "Renewal" | "Inactive";

export enum CUSTOMER_SUBSCRIPTION_TYPE_E {
	UNPAID = 0,
	PAID = 1
}

export interface ICustomerContactDetails {
	id: number;
	designation: string;
	last_name: string;
	first_name: string;
	email_address: string;
	is_subscribed: boolean;
	contact_number: string;
}

export interface IGetCustomersResponseDetails {
	name: string;
	system_integrator_pk: number | null;
	system_integrator_name: string;
	device_count: number | null;
	start_date: string | null;
	expiry_date: string | null;
	days_left: number;
	status: CustomerStatusType;
	user_count: number | null;
	id: number;
	contact_details: ICustomerContactDetails[];
	invoice_no: string;
	building_config: IBuildingConfigDetails[];
	enable_secure_login: boolean;
	subscription: CUSTOMER_SUBSCRIPTION_TYPE_E;
	hide_data_management: boolean;
}

export interface IGetCustomersResponse extends IResponsePagination {
	results: IGetCustomersResponseDetails[];
}

export interface IGetCustomersRequestData {
	page: number;
	search?: string;
	// days_left_sort?: "asc" | "desc";
	status?: CustomerStatusType;
	order_by?: string;
	subscription?: CUSTOMER_SUBSCRIPTION_TYPE_E;
}

export interface IGetCustomersMetricsResponse {
	total_customers: number;
	active_customers: number;
	inactive_customers: number;
	renewal_customers: number;
}

export interface IGetSocietyDevicesResponseDetails {
	device_uuid: string;
	society: number;
	barrier_config: number;
	release_version: string;
	entry_name: string | null;
	exit_name: string | null;
	local_ipv4_address: string;
	global_ipv4_address: string;
	allow_traffic: boolean;
	id: number;
	camera_names: {
		[name: string]: {
			roi: string;
			line: string;
			zoom: number | null;
			width: number;
			height: number;
			is_entry: boolean;
			rtmp_uri: string | null;
			rtsp_uri: string;
			num_lines: number;
			site_name: string;
			latest_camera_snapshot: string;
		};
	};
	device_name: string;
	device_status: "Online" | "Offline";
	added_by_user: number;
	ots_completed: boolean;
	device_status_last_changed_at: string;
	node_sync_enable_status: boolean;
}

export interface IGetSocietyDevicesResponse extends IResponsePagination {
	results: IGetSocietyDevicesResponseDetails[];
}

export interface IGetSocietyDevicesRequestData {
	society: number;
	page: number;
}

// ADD SOCIETY DEVICE
export interface IAddSocietyDeviceRequestData {
	device_uuid: string;
	society: number;
	release_version?: string;
	allow_traffic?: boolean;
	device_name: string;
	ots_completed?: boolean;
	barrier_config: number;
}

export interface IGetSocietyUsersResponseDetails {
	id: number;
	first_name: string;
	last_name: string;
	address: string;
	phone_number: string;
	role: number;
	designation: string;
	email: string;
	is_active: boolean;
	society: [];
	username: string;
	allow_secure_login: boolean;
}

export interface IGetSocietyUsersResponse extends IResponsePagination {
	results: IGetSocietyUsersResponseDetails[];
}

export interface IGetSocietyUsersRequestData {
	society: number;
	page: number;
}

export interface ICreateSocietyUserRequestData {
	username: string;
	first_name: string;
	last_name: string;
	address: string;
	phone_number: string;
	role: number;
	society: number[];
	designation: string;
	password: string;
	email: string;
	allow_secure_login: boolean;
}

export interface ICreateSocietySettingsRequestData {
	mode: number;
	// enable_cloud_sync: true;
	subscription_start_date: string;
	subscription_expiry_date: string;
	society: number;
}

export interface ISocietySettingsResponseData {
	id: number;
	blob_base_url: string;
	plate_img_base_url: string;
	frame_img_base_url: string;
	camera_img_base_url: string;
	mode: number;
	enable_cloud_sync: boolean;
	subscription_start_date: string;
	subscription_expiry_date: string;
	society: number;
}

export interface IEditSocietySettingsRequestData {
	id: number;
	data: {
		mode: number;
		// enable_cloud_sync: true;
		subscription_start_date: string;
		subscription_expiry_date: string;
		society: number;
	};
}

export interface IEditSocietyDeviceRequestData {
	id: number;
	data: {
		device_uuid: string;
		society: number;
		device_name: string;
		barrier_config: number;
		release_version: string;
	};
}

export interface IEditSocietyUserRequestData {
	id: number;
	data: {
		username: string;
		first_name: string;
		last_name: string;
		address: string;
		phone_number: string;
		role: number;
		society: number[];
		designation: string;
		// password: string;
		email: string;
		allow_secure_login: boolean;
	};
}

export interface IRenewSubscriptionRequestData {
	id: number;
	data: {
		/** Subscription Start Date Format - YYYY-MM-DD HH:mm:ss */
		subscription_start_date: string;
		/** Subscription Expiry Date Format - YYYY-MM-DD HH:mm:ss */
		subscription_expiry_date: string;
		society: number;
		username: string;
		password: string;
		invoice_no: string;
	};
}

export interface IDisableSubscriptionRequestData {
	id: number;
	data: {
		username: string;
		society: number;
		password: string;
	};
}
